import Modal from "@/components/Modal";
import "./style.css";

export default class PromotionModal extends Modal {
  static selector = ".promotion-modal";

  constructor(block) {
    super(block);
    this.block = block;
  }

  handlePromotionPopup = () => {
    this.timeout = setTimeout(() => {
      this.open();
    }, 2000);
  };

  onReady() {
    this.newPopupId = JSON.parse(this.block.dataset.promotionModalId);
    this.handlePromotionPopup();
  }

  onResize() {}

  onDestroy() {
    clearTimeout(this.timeout);
  }

  async modalDidClose() {
    document.cookie = `promotion-modal=${this.newPopupId}`;
  }
}
